import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Users
const UserResetPass = () => import('@/views/users/UserResetPass')
const UserAdd = () => import('@/views/users/UserAdd')
const UserUpdate = () => import('@/views/users/UserUpdate')
const UsersList = () => import('@/views/users/UsersList')
const UserLogin = () => import('@/views/users/UserLogin')
const UserVerifyOTP = () => import('@/views/users/UserConfirmOTP')
const UserRegister = () => import('@/views/users/UserRegister')

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const PageNoConfigUser = () => import('@/views/pages/PageNoConfigUser')

// Organization - đơn vị
const OrgList = () => import('@/views/organization/OrgList')

const ThreadList = () => import('@/views/administration/ThreadList')

//NotificationList: Thông báo
const NotificationList = () => import('@/views/notification/NotificationList')

//Customer
const CustomerList = () => import('@/views/customer/CustomerList')

//Product
const ProductList = () => import('@/views/product/ProductList')
const ProductAdd = () => import('@/views/product/ProductAdd')
const ProductUpdate = () => import('@/views/product/ProductUpdate')

//Category
const CategoryList = () => import('@/views/category/CategoryList')

//UOM
const UomList = () => import('@/views/uom/List')

//Warehouse
const WarehouseList = () => import('@/views/warehouse/List')

//Stock
const StockList = () => import('@/views/stock/List')
const StockAdd = () => import('@/views/stock/Add')
const StockUpdate = () => import('@/views/stock/Update')
const CheckInOut = () => import('@/views/stock/CheckInOut')
const ProductLotSerial = () => import('@/views/productlotserial/List')
const CheckFlow = () => import('@/views/stock/CheckFlow')

Vue.use(Router)
let router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  // base: process.env.NODE_ENV === 'development' ? '/' : '/',
  base: '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Trang chủ',
      component: TheContainer,
      children: [
        {
          path: '/dashboard.html',
          name: 'Thống kê',
          component: Dashboard,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/stock-management',
          redirect: '/stock-management/list.html',
          name: 'Quản lý kho',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách phiếu nhập xuất',
              component: StockList
            },
            {
              path: 'create.html',
              name: 'Tạo phiếu nhập xuất',
              component: StockAdd
            },
            {
              path: ':id/update.html',
              name: 'Cập nhật phiếu nhập xuất',
              component: StockUpdate
            },
            {
              path: 'checkInOut.html',
              name: 'Kiểm tra tồn kho',
              component: CheckInOut
            },
            {
              path: 'productLotSerial.html',
              name: 'Tra cứu thông tin',
              component: ProductLotSerial
            },
                        {
              path: 'check-flow.html',
              name: 'Luân chuyển hàng hóa',
              component: CheckFlow
            },
          ]
        },
        {
          path: '/warehouse-management',
          redirect: '/warehouse-management/list.html',
          name: 'Quản lý kho',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách kho',
              component: WarehouseList
            }
          ]
        },
        {
          path: '/product-management',
          redirect: '/product-management/list.html',
          name: 'Danh mục sản phẩm',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách sản phẩm',
              component: ProductList
            },
            {
              path: 'create.html',
              name: 'Tạo sản phẩm',
              component: ProductAdd
            },
            {
              path: ':id/update.html',
              name: 'Cập nhật sản phẩm',
              component: ProductUpdate
            },
          ]
        },
        {
          path: '/category-management',
          redirect: '/category-management/list.html',
          name: 'Danh mục sản phẩm',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách danh mục',
              component: CategoryList
            }
          ]
        },
        {
          path: '/uom-management',
          redirect: '/uom-management/list.html',
          name: 'Danh mục ĐVT',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách ĐVT',
              component: UomList
            }
          ]
        },
        {
          path: '/customer-management',
          redirect: '/customer-management/list.html',
          name: 'Danh mục khách hàng',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách khách hàng',
              component: CustomerList
            }
          ]
        },
        {
          path: '/administrator',
          redirect: '/administrator/user-activity-log.html',
          name: 'Quản trị',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'organization.html',
              name: 'Danh sách đơn vị',
              component: OrgList
            },
            {
              path: 'thread.html',
              name: 'Quản lý tiến trình',
              component: ThreadList
            },
          ]
        },
        {
          path: '/user-management',
          redirect: '/user-management/managed-users.html',
          name: 'Quản lý tài khoản',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-users.html',
              name: 'Danh sách tài khoản',
              component: UsersList
            },
            {
              path: 'new.html',
              name: 'Tạo tài khoản',
              component: UserAdd
            },
            {
              path: ':id/managed-user.html',
              name: 'Cập nhật tài khoản',
              component: UserUpdate
            },
          ]
        },
        {
          path: '/notification-management',
          redirect: '/notification-management/managed-notification.html',
          name: 'Danh sách thông báo',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-notification.html',
              name: 'Danh sách thông báo',
              component: NotificationList
            }
          ]
        }
      ]
    },
    {
      path: '/login.html',
      name: 'UserLogin',
      component: UserLogin,
    },
    {
      path: '/authorize',
      name: 'UserLogin',
      component: UserLogin,
    },
    {
      path: '/verify.html',
      name: 'UserVerifyOTP',
      component: UserVerifyOTP,
    },
    {
      path: '/register.html',
      name: 'UserRegister',
      component: UserRegister,
    },
    {
      path: '/user',
      name: 'user',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'reset-password.html',
          name: 'UserResetPass',
          component: UserResetPass
        }
      ]
    },
    {
      path: '/errors',
      redirect: '/errors/404',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        },
        {
          path: 'pending-config',
          name: 'pendingConfig',
          component: PageNoConfigUser
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true,
      }
    },

  ]
})

export default router
